import { apiService } from '../../shared/services/apiService';
import {
  EntityInbodyPin,
  EntityInbodyPinForPaymentResult,
} from '../interfaces/EntityInbodyPin';

export const entityInbodyPinCodeService = {
  async getPin(entityId: number) {
    const resp = await apiService.get<EntityInbodyPin>(
      `api/entity/${entityId}/inbody-pin`,
    );

    return resp.data;
  },

  async patchPin(entityId: number, pin: Partial<EntityInbodyPin>) {
    const resp = await apiService.patch<EntityInbodyPin>(
      `api/entity/${entityId}/inbody-pin`,
      pin,
    );

    return resp.data;
  },

  async getPinForPaymentResult(
    entityId: number,
    config: { ignoreErrorCodes?: number[] } = {},
  ) {
    const response = await apiService.get<EntityInbodyPinForPaymentResult>(
      `/api/scan-iq/entity/${entityId}/inbody-pin`,
      config,
    );

    return response.data;
  },
};
